import { openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openRestoreOptionsModal())),
    type: "button",
    class: "btn btn-sm max-h-34 btn-bg line-height me-12"
  }, " Restore To Default "))
}